import {
  deltaClass,
  fmtScore,
  MCI_MUTED,
  statusBadgeClass,
  tierDotClass,
  tierPillClass,
} from "../../Utils/Helper/sponsorEngagementUi";

export const TierPill = ({
  tier,
  className = "",
}: {
  tier: string | null | undefined;
  className?: string;
}) => {
  if (!tier) return <span className={MCI_MUTED}>—</span>;
  return (
    <span className={tierPillClass(tier, className)}>
      <span className={tierDotClass(tier)} />
      {tier}
    </span>
  );
};

export const StatusBadge = ({
  status,
  label,
}: {
  status: "completed" | "pending" | "draft" | "overdue";
  label?: string;
}) => {
  const defaults: Record<string, string> = {
    completed: "Completed",
    pending: "Pending",
    draft: "Draft",
    overdue: "Overdue",
  };
  return (
    <span className={statusBadgeClass(status)}>
      {label ?? defaults[status]}
    </span>
  );
};

export const CompositeDelta = ({
  delta,
}: {
  delta: number | null | undefined;
}) => {
  if (delta == null || Number.isNaN(delta)) return null;
  if (Math.abs(delta) < 0.05) {
    return <span className={deltaClass("flat")}>→ flat</span>;
  }
  if (delta > 0) {
    return <span className={deltaClass("up")}>▲ +{fmtScore(delta, 2)}</span>;
  }
  return <span className={deltaClass("down")}>▼ {fmtScore(delta, 2)}</span>;
};
